module.exports = __webpack_public_path__ + "article.bed450a8.png";